import styled from 'styled-components';
import { Container } from '../components';

const StyledWelcome = styled(Container)`
  height: 100vh;
  padding: 16px;
  box-sizing: border-box;
  flex-direction: column;
  flex: 1;
  p {
    text-align: center;
  }
  .top-bar-container {
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding: 16px;
    padding-bottom: 0;
    .user-menu-container {
      display: flex;
      align-items: center;
      .side-menu-container {
        border: 1px solid #C1C1C1;
        border-radius: 16px;
        position: absolute;
        top: 72px;
        right: 24px;
        min-width: 250px;
        background: rgb(251, 250, 255);
        flex-direction: column;
        align-items: stretch;
        transition: ease-in-out .3s all;
        transform: translateY(-16px);
        opacity: 0.0;
        visibility: hidden;
        &.visible {
          transform: translateY(0);
          opacity: 1;
          visibility: visible;
        }
        .side-menu-content-container {
          flex: 1;
          max-height: 100%;
          flex-direction: column;
          overflow: auto;
          padding: 0px 24px;
          align-items: center;
          justify-content: flex-start;
          button {
            padding: 0;
            align-items: center;
            justify-content: space-between;
            border-radius: 0;
            background: rgb(251, 250, 255);
            a{
              text-decoration: none;
              
              
            }
              p, svg {
                color: #A62353;
                font-size: 18px;
              }
            border-bottom: 1px solid ;
            &:nth-last-of-type(1) {
              border-bottom: 0px;
                &:hover {
                  p, svg {
                  }
                }
            }
          }
        }
      }
      .outer-area-container {
        height: 100vh;
        width: 100vw;
        position: absolute;
        top: 0;
        right: 0;
        visibility: hidden;
        &.visible {
          visibility: visible;
        }
      }
    }
  }
  .title-section-container {
    display: flex;
    flex-direction: column;
    align-items: space-between;
    p.h1 {
      color: #1932a0;
      padding-top: 82px;
      font-size: 48px;
      line-height: 54px;
      @media (max-width: 768px) {
        padding-top: 0px;
        margin: 0;
        padding-bottom: 0px;
        font-size: 32px;
      }
    }
    p.h3 {
      color: #1932a0;
      font-size: 24px;
      padding-bottom: 44px;
      line-height: 24px;
      @media (max-width: 768px) {
        font-size: 20px;
      }
    }
  }
  .background-container {
    position: absolute;
    z-index: -1;
    width: 100%;
    left: 0;
    bottom: 0;
    display: flex;
    img {
      width: 100%;
    }
  }
  /* --- Pistil Next-styled chooser hero (fonts + colors mirror Pistil Next) --- */
  @keyframes livePulse {
    0% { box-shadow: 0 0 0 0 rgba(22, 163, 74, 0.55); opacity: 1; }
    70% { box-shadow: 0 0 0 6px rgba(22, 163, 74, 0); opacity: 0.75; }
    100% { box-shadow: 0 0 0 0 rgba(22, 163, 74, 0); opacity: 1; }
  }
  .hero {
    flex: 1;
    width: 100%;
    max-width: 1120px;
    margin: 0 auto;
    padding: 40px 24px 64px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    font-family: var(--pn-font-sans);
  }
  .hero-head {
    text-align: center;
    max-width: 780px;
    margin-bottom: 44px;
  }
  .update-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 14px;
    margin-bottom: 22px;
    border-radius: 9999px;
    background: var(--pn-purple-dim);
    border: 1px solid var(--pn-border-bright);
    color: var(--pn-purple-light);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
  }
  .hero-title {
    font-family: var(--pn-font-display);
    font-weight: 800;
    font-size: 46px;
    line-height: 1.12;
    color: var(--pn-text-primary);
    margin: 0 0 18px;
    .accent { color: var(--pn-purple-primary); }
    @media (max-width: 860px) { font-size: 32px; }
  }
  .hero-sub {
    font-size: 18px;
    line-height: 1.5;
    color: var(--pn-text-secondary);
    margin: 0;
  }
  .hero-cards {
    display: flex;
    gap: 24px;
    width: 100%;
    align-items: stretch;
    justify-content: center;
    @media (max-width: 860px) {
      flex-direction: column;
      align-items: center;
    }
  }
  .pn-card {
    flex: 1 1 0;
    max-width: 540px;
    display: flex;
    flex-direction: column;
    text-align: left;
    background: var(--pn-bg-primary);
    border: 1px solid var(--pn-border-bright);
    border-radius: 24px;
    padding: 30px;
    box-shadow: 0 12px 44px rgba(139, 92, 246, 0.12);
    box-sizing: border-box;
    @media (max-width: 860px) { max-width: 540px; width: 100%; }
  }
  .pn-card-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 28px;
  }
  .pn-icon {
    width: 52px;
    height: 52px;
    border-radius: 16px;
    background: var(--pn-purple-primary);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .live-badge {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 5px 12px;
    border-radius: 9999px;
    border: 1px solid var(--pn-border);
    color: var(--pn-purple-light);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    .live-dot {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: var(--pn-green);
      animation: livePulse 2s ease-in-out infinite;
    }
  }
  .pn-title {
    font-family: var(--pn-font-display);
    font-weight: 700;
    font-size: 30px;
    color: var(--pn-text-primary);
    margin: 0 0 12px;
  }
  .pn-desc {
    font-size: 15px;
    line-height: 1.6;
    color: var(--pn-text-secondary);
    margin: 0 0 24px;
    flex: 1;
    text-align: left;
  }
  .pn-divider {
    height: 1px;
    background: var(--pn-border);
    margin: 0 0 20px;
  }
  .pn-btn {
    align-self: flex-start;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 12px 22px;
    border: none;
    border-radius: 9999px;
    background: var(--pn-purple-primary);
    color: #fff;
    font-family: var(--pn-font-sans);
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: background .2s ease, transform .1s ease;
    &:hover { background: var(--pn-purple-light); }
    &:active { transform: translateY(1px); }
  }
  .legacy-col {
    flex: 1 1 0;
    max-width: 380px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    @media (max-width: 860px) { max-width: 540px; width: 100%; }
  }
  .legacy-card {
    display: flex;
    flex-direction: column;
    flex: 1;
    background: var(--pn-bg-primary);
    border: 1px solid var(--pn-border);
    border-radius: 20px;
    padding: 24px;
    box-sizing: border-box;
  }
  .legacy-top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex: 1;
  }
  .legacy-title {
    font-family: var(--pn-font-display);
    font-weight: 700;
    font-size: 18px;
    color: var(--pn-text-primary);
    margin: 0 0 4px;
    text-align: left;
  }
  .legacy-caption {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--pn-text-dim);
  }
  .legacy-icon {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    background: var(--pn-bg-tertiary);
    color: var(--pn-text-dim);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .legacy-btn {
    margin-top: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: 100%;
    padding: 11px 16px;
    border: 1px solid var(--pn-border);
    border-radius: 12px;
    background: transparent;
    color: var(--pn-text-secondary);
    font-family: var(--pn-font-sans);
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: border-color .2s ease, color .2s ease, background .2s ease;
    &:hover {
      border-color: var(--pn-purple-primary);
      color: var(--pn-purple-primary);
      background: var(--pn-purple-dim);
    }
  }
  .cards-section-container {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 40px;
    align-content: baseline;
    .background-container {
      position: absolute;
      z-index: -1;
      width: 100%;
      display: flex;
      flex: 1;
      bottom: 0;
      img {
        width: 100%;
      }
    }
    .card-container {
      flex: 1;
      max-width: 250px;
      @media (max-width: 768px) {
        max-width: 100%;
        padding: 4px;
      }
      justify-content: space-between;
      box-sizing: border-box;
      display: flex;
      background: white;
      align-items: center;
      &.sales {
        color: #6E51F6;
        button {
          background: #6E51F6;
        }
      }
      &.brands {
        color: #017381;
        button {
          background: #017381;
        }
      }
      &.brands2 {
        color: #017381;
        button {
          background: #017381;
        }
      }
      &.analytics {
        color: #f25757;
        button {
          background: #f25757;
        }
      }
      &.retail {
        color: #0057B2;
        button {
          background: #0057B2;
        }
      }
      &.insights {
        color: #0057B2;
        button {
          background: #0057B2;
        }
      }
      &.vmiq {
        color: #1932a0;
        button {
          background: #1932a0;
        }
      }
      &.pistilnext {
        color: #6E51F6;
        button {
          background: #6E51F6;
        }
      }
      filter: drop-shadow(0px 4px 20px rgba(62, 62, 62, 0.37));
      padding: 32px;
      gap: 8px;
      border: 1px solid;
      border-radius: 40px;
      flex-direction: column;
      .app-icon-container {
        padding-bottom: 4px;
      }
      .app-title-container {
      }
      button {
        padding: 0px 24px;
        @media (max-width: 768px) {
          width: 55px;
          padding: 0px;
          p {
            width: 3ch;
            overflow: hidden;
          }
        }
        border-radius: 32px;
        border: none;
        white-space: nowrap;
        p {
          line-height: 16px;
          font-weight: 900;
          font-size: 16px;
          color: white;
        }
        &:hover {
          cursor: pointer;
        }
      }
      @media (max-width: 768px) {
        flex-direction: row;
      }
  }
}`;

export default StyledWelcome;